import {StudentTicketPaymentStatus} from "./StudentTicketPaymentStatus";

export const StudentTicketPaymentStatusColorMapping: Map<StudentTicketPaymentStatus, string> = new Map([
  [StudentTicketPaymentStatus.PENDING, "yellow"],
  [StudentTicketPaymentStatus.EXTERNAL, "green"],
  [StudentTicketPaymentStatus.PAID, "green"],
  [StudentTicketPaymentStatus.OVERPAID, "red"],
  [StudentTicketPaymentStatus.UNDERPAID, "red"]
]);

export function getTicketPaymentStatusColor(status: StudentTicketPaymentStatus | undefined): string {
  if(status) {
    return 'var(--traffic-light-' + StudentTicketPaymentStatusColorMapping.get(status) + ', $traffic-light-' + StudentTicketPaymentStatusColorMapping.get(status) + ')';
  }
  else {
    return 'var(--traffic-light-' + "off" + ', $traffic-light-' + "off" + ')';
  }
}
